import React, { useState, useEffect } from 'react';
import { removeTrailingSlash } from '@Utils/commonUtils';
import validationHandler from '@Service/validationService';
import { SystemActionPanel } from './SystemItem.style';
import { buttons, forms, layouts } from 'seal-ui-components';

const EditForm = props => {
    const {
        friendlyName,
        sealUrl,
        setOption,
        option,
        editSealSystem,
        id,
        sealSystems,
        index
    } = props;
    const [name, setName] = useState('');
    const [serverAddress, setServerAddress] = useState('');
    const [urlErrorMessage, setUrlErrorMessage] = useState([]);
    const [nameErrorMessage, setNameErrorMessage] = useState([]);

    useEffect(() => {
        setServerAddress(sealUrl);
        setName(friendlyName);
    }, []);

    const EditSubmitClickHandler = () => {
        const sealServerUrl = removeTrailingSlash(serverAddress);
        const validationObject = validationHandler(id, serverAddress, name, sealSystems);
        if (validationObject.valid) {
            editSealSystem(id, sealServerUrl, name);
            setOption(() => ({ ...option, visible: false }));
        } else {
            setUrlErrorMessage([validationObject.url]);
            setNameErrorMessage([validationObject.name]);
        }
    };

    const EditCancelClickHandler = () => {
        setOption(() => ({ ...option, visible: false }));
    };
    return (
        <SystemActionPanel id="System__div">
            <forms.TextField
                id={`edit_system_name_${index}`}
                label="System name"
                name="edit-seal-url-friendly-name"
                placeholder="Name your system"
                onChange={e => setName(e.currentTarget.value)}
                value={name}
                onKeyPress={event =>
                    event.key === 'Enter' && friendlyName !== name ? EditSubmitClickHandler() : null
                }
                errors={nameErrorMessage}
            />

            <forms.TextField
                id={`edit_server_address_${index}`}
                label="Server address"
                name="edit-seal-url"
                placeholder="https://sealserver.seal-software.net"
                onChange={e => setServerAddress(e.currentTarget.value)}
                value={serverAddress}
                onKeyPress={event =>
                    event.key === 'Enter' && sealUrl !== serverAddress
                        ? EditSubmitClickHandler()
                        : null
                }
                errors={urlErrorMessage}
            />
            <layouts.HorizontalBox>
                <buttons.Button
                    appearance="secondary"
                    size="large"
                    id={`cancel_system_edit_${index}`}
                    onClick={() => EditCancelClickHandler()}
                >
                    Cancel
                </buttons.Button>
                <layouts.BoxSpacer />
                <buttons.Button
                    id={`save_edit_changes_${index}`}
                    appearance="primary"
                    size="large"
                    onClick={() => EditSubmitClickHandler()}
                    disabled={
                        (friendlyName === name && sealUrl === serverAddress) ||
                        serverAddress === '' ||
                        name === ''
                    }
                >
                    Save Changes
                </buttons.Button>
            </layouts.HorizontalBox>
        </SystemActionPanel>
    );
};

export default EditForm;
